module.exports = __webpack_public_path__ + "img/3.5dcb36d8.png";